<template>

<core-modal v-on:close="onCancelClick" icon="caret-left">

	<template v-slot:head>

		Delete Tag Family

	</template>

	<template v-slot:default>

		<p>Are you sure you wish to delete the tag family <b>{{ family.name }}</b>?</p>

	</template>

	<template v-slot:foot>

		<core-button theme="red" v-on:click.native="onConfirmClick" :loading="is.loading">Confirm</core-button>
		<core-button theme="blue" v-on:click.native="onCancelClick">Cancel</core-button>

	</template>

</core-modal>

</template>

<script>

export default {

	props: ['data'],

	data: function() {

		return {

			is: {
				loading: false
			}

		}

	},

	computed: {

		family: function() {

			return this.$store.getters['data/tagFamilies'][this.data.family]

        }

	},

	methods: {

		onConfirmClick: function() {

			this.is.loading = true

            this.$api.delete('tags/family/delete', {
				family: this.data.family
			}).then(function(family) {

                var tags = this.$_.filter(this.$store.getters['data/tags/list'], function(tag) {

                    return tag.family === this.data.family

                }.bind(this))

                this.$_.each(tags, function(tag) {

				    this.$store.commit('data/tags/remove', [tag])

                }.bind(this))

				this.$store.commit('data/tagFamilies/remove', [family])

				this.$emit('close')

				this.$pubsub.$emit('open.modal', {
					id: 'tagManage'
				})

			}.bind(this), function() {

				this.is.loading = false

			}.bind(this)) 

		},

		onCancelClick: function() {

			this.$emit('close')

			this.$pubsub.$emit('open.modal', {
				id: 'tagFamilyEdit',
				family: this.data.family
			})

		}

	}

}

</script>

<style scoped>

</style>